import { createBrowserRouter } from '@datadog/browser-rum-react/react-router-v7';
import { Outlet, RouterProvider } from 'react-router';

import { DialogServiceProvider } from '@infinex/web-shared/components';

import { ErrorBoundary } from './components/ErrorBoundary';
import { routes } from './core/routes';
import { PopupLayout } from './layouts/PopupLayout';
import { PublicPageLayout } from './layouts/PublicPageLayout';
import AuthorizeSigningRequestPage from './pages/authorize/AuthorizeSigningRequest';
import NotFoundPage from './pages/NotFound';
import { GlobalLogicContainer } from './providers/GlobalLogicContainer';

const router = createBrowserRouter([
  {
    element: (
      <ErrorBoundary>
        <GlobalLogicContainer />
      </ErrorBoundary>
    ),
    children: [
      {
        element: <PublicPageLayout />,
        children: [
          {
            path: '*',
            element: <NotFoundPage />,
          },
        ],
      },
      // V2 routes
      {
        element: (
          <PopupLayout>
            <Outlet />
          </PopupLayout>
        ),
        children: [
          {
            path: routes.v2.authorize.signingRequest,
            element: <AuthorizeSigningRequestPage />,
          },
        ],
      },
    ],
  },
]);

function App() {
  return (
    <DialogServiceProvider>
      <RouterProvider router={router} />
    </DialogServiceProvider>
  );
}

export default App;
